import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { Button, Card, Col, Form, Modal, Row, Spinner, Popover, OverlayTrigger, InputGroup } from 'react-bootstrap';

import Select from 'react-select';
import { AuthContext } from '../../auth/AuthContext';
import { useContextInfo } from '../../context/ContextInfo';
import { UserContext } from '../../context/user/ContextUser';
import { useForm } from '../../hooks/useForm';
import { uploadFile } from '../../api/fetch';
import { asuntos } from '../../data/resument';

const ModAddTk = ({ show, onClose, callBk, id }) => {
    const { auth } = useContext(AuthContext);
    const [send, setSend] = useState(false);
    const [validated, setValidated] = useState(false);

    const { setResp } = useContextInfo();
    const { usersState } = useContext(UserContext);
    const fecha_reporte = moment().format('YYYY-MM-DD hh:mm:ss');

    const [cliente, setCliente] = useState(null);
    const [file, setFile] = useState();
    const saveFile = (e) => {
        setFile(e.target.files[0]);
    };

    useEffect(() => {
        setCliente(id);
    }, [id]);

    const [values, handleInputChange, reset, setFormValue] = useForm({
        solicitante: '',
        asunto: '',
        fecha_reporte,
        contenido: '',
        prioridad: 'NORMAL',
    });
    const onSubmit = async (e) => {
        e.preventDefault();
        if (send) return;
        const form = e.currentTarget;

        if (form.checkValidity() === false && cliente.value === '') {
            setValidated(true);
        } else {
            setSend(true);
            let bodyContent = new FormData();

            bodyContent.append('archivo', file);
            bodyContent.append('contenido', values.contenido);
            bodyContent.append('fecha', values.fecha_reporte);
            bodyContent.append('idagent', auth.uid);
            bodyContent.append('solicitante', values.solicitante);
            bodyContent.append('asunto', values.asunto);
            bodyContent.append('prioridad', values.prioridad);
            bodyContent.append('idcliente', cliente.value);
            bodyContent.append('state', 0);
            const res = await uploadFile(bodyContent, 'tickets/ticketopen/0', 'PUT');
            setResp(res);
            if (res.ok) {
                reset();
                setCliente(null);
                setFile();
                onClose();
                callBk();
            }
        }
        setSend(false);
    };
    const setAs = (value) => {
        setFormValue({ ...values, asunto: value });
    };
    const popover = (
        <Popover>
            <Popover.Header as="h3">Opciones</Popover.Header>
            <Popover.Body>
                {' '}
                <ul style={{ maxHeight: '300px', overflowY: 'auto' }} className="list-group">
                    {asuntos.map((op, i) => (
                        <li key={i} className="p-1" style={{ cursor: 'pointer' }} onClick={() => setAs(op.value)}>
                            <div className="fs-6">{op.value}</div>
                        </li>
                    ))}{' '}
                </ul>
            </Popover.Body>
        </Popover>
    );
    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header onHide={onClose} closeButton>
                <h4 className="modal-title">Nuevo Ticket</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        <Row>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom19">
                                                    <Form.Label>Cliente</Form.Label>
                                                    <Select
                                                        className="react-select"
                                                        placeholder={'Cliente'}
                                                        maxMenuHeight="550px"
                                                        value={cliente}
                                                        onChange={setCliente}
                                                        options={usersState.clientes}
                                                        classNamePrefix="react-select"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom19">
                                                    <Form.Label>Prioridad ticket</Form.Label>
                                                    <Form.Select
                                                        value={values.prioridad}
                                                        name="prioridad"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="ALTA">ALTA</option>
                                                        <option value="NORMAL">NORMAL</option>
                                                        <option value="BAJA">BAJA</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom17">
                                                    <Form.Label>Solicitante</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={values.solicitante}
                                                        name="solicitante"
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom17">
                                                    <Form.Label>Asunto</Form.Label>

                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            value={values.asunto}
                                                            name="asunto"
                                                            disabled
                                                            onChange={handleInputChange}
                                                        />{' '}
                                                        <OverlayTrigger
                                                            trigger="focus"
                                                            placement="right"
                                                            overlay={popover}>
                                                            <Button size="sm" variant="outline-dark">
                                                                <i className="mdi mdi-arrow-down-drop-circle-outline" />{' '}
                                                            </Button>
                                                        </OverlayTrigger>{' '}
                                                    </InputGroup>
                                                </Form.Group>{' '}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {' '}
                                                <Form.Group>
                                                    <Form.Label htmlFor="file">Adjuntar archivo</Form.Label>
                                                    <Form.Control
                                                        type="file"
                                                        onChange={saveFile}
                                                        id="upload"
                                                        accept="image/*, .pdf, .doc"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Form.Group className="mb-3" controlId="validationCustom121">
                                            <Form.Label> Detalles del ticket </Form.Label>
                                            <Form.Control
                                                type="text"
                                                as="textarea"
                                                value={values.contenido}
                                                name="contenido"
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>{' '}
                                        {send ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModAddTk;
